import request from '@/utils/request'

/**
 * 用户提交代找工单
 * @param {Object} data - { productName, productDescription, images }
 * @returns {Promise}
 */
export function submitAgentWorkOrder(data) {
    return request({
        url: '/shop/agentWorkOrder/userSubmit',
        method: 'post',
        data
    })
}
/**
 * 获取用户的代找记录列表
 * @param {Object} params - { pageNum, pageSize }
 * @returns {Promise}
 */
export function getUserAgentWorkOrderList(params) {
    return request({
        url: '/shop/agentWorkOrder/userList',
        method: 'get',
        params
    })
}
/**
 * 删除代找记录
 * @param {string|number} ids - 代找工单ID，多个ID用逗号分隔
 * @returns {Promise}
 */
export function deleteAgentWorkOrder(ids) {
    return request({
        url: `/shop/agentWorkOrder/${ids}`,
        method: 'delete'
    })
}

/**
 * 获取代找工单动态配置
 * @returns {Promise}
 */
export function getAgentWorkOrderFormConfig() {
    return request({
        url: '/shop/agentWorkOrder/api/agentWorkOrderFormConfig',
        method: 'get'
    })
}
